export type ChecklistBehavior = {
    evaluationBehavior: string;
    displayText: string;
};

export type ChecklistCategory = {
    category: string;
    behaviors: ChecklistBehavior[];
    saleDetectedBehaviors: ChecklistBehavior[];
};

export const CHECKLIST_CATEGORIES: ChecklistCategory[] = [
    {
        category: "Serve & Solve",
        behaviors: [
            {
                evaluationBehavior: "Greeting",
                displayText: "Greeting",
            },
            {
                evaluationBehavior: "Show Compassion",
                displayText: "Show Empathy",
            },
            {
                evaluationBehavior: "Reassurance",
                displayText: "Reassurance",
            },
            {
                evaluationBehavior: "Set Expectations",
                displayText: "Set Expectations",
            },
            {
                evaluationBehavior: "Confirm Resolution",
                displayText: "Test & Confirm Resolution",
            },
        ],
        saleDetectedBehaviors: [],
    },
    {
        category: "Sell - Smart Offer",
        behaviors: [
            {
                evaluationBehavior: "Transition Statement",
                displayText: "Transition Statement",
            },
            {
                evaluationBehavior: "Discovery Questions",
                displayText: "Discovery Questions",
            },
            {
                evaluationBehavior: "Engagement Questions",
                displayText: "Engagement Questions",
            },
            {
                evaluationBehavior: "Core Benefit - Non Partner Coverage",
                displayText: "Core Benefit - Non Partner Coverage",
            },
            {
                evaluationBehavior: "Core Benefit - Future Purchases",
                displayText: "Core Benefit - Future Purchases",
            },
            {
                evaluationBehavior: "Core Benefit - RRR Explained",
                displayText: "Core Benefit - RRR Explained",
            },
            {
                evaluationBehavior: "Price",
                displayText: "Price",
            },
            {
                evaluationBehavior: "Ask for Sale",
                displayText: "Ask for Sale",
            },
        ],
        saleDetectedBehaviors: [
            {
                evaluationBehavior: "Ask to Send Enrollment Link",
                displayText: "Ask to Send Enrollment Link",
            },
            {
                evaluationBehavior: "Resolve the Customer's Concern",
                displayText: "Resolve the Customer's Concern",
            },
            {
                evaluationBehavior: "Celebrate Enrollment",
                displayText: "Celebrate Enrollment",
            },
            {
                evaluationBehavior: "Thank & Reinforce",
                displayText: "Thank & Reinforce",
            },
        ],
    },
    {
        category: "Sell - Closing",
        behaviors: [
            {
                evaluationBehavior: "Survey",
                displayText: "Survey",
            },
            {
                evaluationBehavior: "Goodbye w/ Rapport",
                displayText: "Goodbye w/ Rapport",
            },
        ],
        saleDetectedBehaviors: [],
    },
];

export const CALL_FLOW_UPDATED_CHECKLIST_CATEGORIES_VERIZON: ChecklistCategory[] = [
    {
        category: "Serve & Solve",
        behaviors: [
            {
                evaluationBehavior: "Greeting",
                displayText: "Greeting",
            },
            {
                evaluationBehavior: "Show Compassion",
                displayText: "Show Empathy",
            },
            {
                evaluationBehavior: "Reassurance",
                displayText: "Reassurance",
            },
            {
                evaluationBehavior: "Verification",
                displayText: "Verification",
            },
            {
                evaluationBehavior: "Account Assessment",
                displayText: "Account Assessment",
            },
            {
                evaluationBehavior: "Set Expectations",
                displayText: "Set Expectations",
            },
            {
                evaluationBehavior: "Advanced Discovery",
                displayText: "Advanced Discovery",
            },
            {
                evaluationBehavior: "Confirm Resolution",
                displayText: "Test & Confirm Resolution",
            },
        ],
        saleDetectedBehaviors: [],
    },
    {
        category: "Sell - Smart Offer",
        behaviors: [
            {
                evaluationBehavior: "Transition Statement",
                displayText: "Transition Statement",
            },
            {
                evaluationBehavior: "Core Benefit - Non Partner Coverage",
                displayText: "Core Benefit - Non Partner Coverage",
            },
            {
                evaluationBehavior: "Core Benefit - Future Purchases",
                displayText: "Core Benefit - Future Purchases",
            },
            {
                evaluationBehavior: "Core Benefit - RRR Explained",
                displayText: "Core Benefit - RRR Explained",
            },
            {
                evaluationBehavior: "Price",
                displayText: "Price",
            },
            {
                evaluationBehavior: "Ask for Sale",
                displayText: "Ask for Sale",
            },
            {
                evaluationBehavior: "Smart Offer Conversational Language",
                displayText: "Smart Offer Conversational Language",
            },
        ],
        saleDetectedBehaviors: [
            {
                evaluationBehavior: "Ask to Send Enrollment Link",
                displayText: "Ask to Send Enrollment Link",
            },
            {
                evaluationBehavior: "Resolve the Customer's Concern",
                displayText: "Resolve the Customer's Concern",
            },
            {
                evaluationBehavior: "Celebrate Enrollment",
                displayText: "Celebrate Enrollment",
            },
            {
                evaluationBehavior: "Thank & Reinforce",
                displayText: "Thank & Reinforce",
            },
        ],
    },
    {
        category: "Sell - Closing",
        behaviors: [
            {
                evaluationBehavior: "Goodbye w/ Rapport",
                displayText: "Goodbye w/ Rapport",
            },
        ],
        saleDetectedBehaviors: [],
    },
];

export const CALL_FLOW_UPDATED_CHECKLIST_CATEGORIES_ATT: ChecklistCategory[] = [
    {
        category: "Serve & Solve",
        behaviors: [
            {
                evaluationBehavior: "Greeting",
                displayText: "Greeting",
            },
            {
                evaluationBehavior: "Show Compassion",
                displayText: "Show Empathy",
            },
            {
                evaluationBehavior: "Reassurance",
                displayText: "Reassurance",
            },
            {
                evaluationBehavior: "Verification",
                displayText: "Verification",
            },
            {
                evaluationBehavior: "Account Assessment",
                displayText: "Account Assessment",
            },
            {
                evaluationBehavior: "Set Expectations",
                displayText: "Set Expectations",
            },
            {
                evaluationBehavior: "Advanced Discovery",
                displayText: "Advanced Discovery",
            },
            {
                evaluationBehavior: "Confirm Resolution",
                displayText: "Test & Confirm Resolution",
            },
        ],
        saleDetectedBehaviors: [],
    },
    {
        category: "Sell - Smart Offer",
        behaviors: [
            {
                evaluationBehavior: "Transition Statement",
                displayText: "Transition Statement",
            },
            {
                evaluationBehavior: "Core Benefit - Non Partner Coverage",
                displayText: "Core Benefit - Non Partner Coverage",
            },
            {
                evaluationBehavior: "Core Benefit - Future Purchases",
                displayText: "Core Benefit - Future Purchases",
            },
            {
                evaluationBehavior: "Core Benefit - RRR Explained",
                displayText: "Core Benefit - RRR Explained",
            },
            {
                evaluationBehavior: "Price",
                displayText: "Price",
            },
            {
                evaluationBehavior: "Ask for Sale",
                displayText: "Ask for Sale",
            },
            {
                evaluationBehavior: "Disclosures Statement",
                displayText: "Disclosures Statement",
            },
            {
                evaluationBehavior: "Smart Offer Conversational Language",
                displayText: "Smart Offer Conversational Language",
            },
        ],
        saleDetectedBehaviors: [
            {
                evaluationBehavior: "Ask to Enroll",
                displayText: "Ask to Enroll",
            },
            {
                evaluationBehavior: "Resolve the Customer's Concern",
                displayText: "Resolve the Customer's Concern",
            },
            {
                evaluationBehavior: "Celebrate Enrollment",
                displayText: "Celebrate Enrollment",
            },
            {
                evaluationBehavior: "Thank & Reinforce",
                displayText: "Thank & Reinforce",
            },
        ],
    },
    {
        category: "Sell - Closing",
        behaviors: [
            {
                evaluationBehavior: "Survey",
                displayText: "Survey",
            },
            {
                evaluationBehavior: "Goodbye w/ Rapport",
                displayText: "Goodbye w/ Rapport",
            },
        ],
        saleDetectedBehaviors: [],
    },
];
